import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { environment } from '@env/environment';

import { AppModule } from './app/app.module';

if (environment.production) {
	enableProdMode();
}

platformBrowser()
	.bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
	.catch((err) => console.error(err));
